module.exports = __webpack_public_path__ + "img/mezzanine-2.4b240977.jpg";